import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, CreditCard } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
import { trackEvent } from './metaPixel';
export function BonusStack() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/fRsWVpwB8EPYk5D9Lp5NgM/ChatGPT_Image_11_may_2026,_01_23_34_a.m..png',
    imageAlt: 'Mockup del libro Desata a tu Diosa Letal Interior',
    title: 'Libera a tu Diosa Letal Interior',
    desc: 'Guía completa (PDF premium)',
    value: 29999
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/6J5jD9t7PHM3GryasUQyuj/ChatGPT_Image_11_may_2026,_08_17_33_p.m..png',
    imageAlt: 'Mockup del cuaderno 30 días ejercicios Diosa Letal: Adictiva',
    title: 'Cuaderno de Ejercicios 30 Días',
    desc: '“Secretos para Volverte Adictiva” (Workbook práctico)',
    value: 25000
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/qSiGSNjVjhjE66139L73Rg/Captura_de_pantalla_2026-05-11_a_la(s)_8.30.49_p._m..png',
    imageAlt: 'Mockup de meditación guiada Ser Adictiva en celular',
    title: 'Meditación Guiada "Ser Adictiva"',
    desc: 'Activación de tu energía magnética y letal (Audio)',
    value: 12800
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/uzSYG36g3KsmvjNhyk342J/Captura_de_pantalla_2026-05-14_a_la(s)_10.02.53_p._m..png',
    imageAlt: 'Ebook Citas Magnéticas: Cómo Conseguirlas en Apps y en la Vida Cotidiana',
    title: 'Citas Magnéticas: Cómo Conseguirlas en Apps y en la Vida Cotidiana',
    desc: 'Ebook sobre cómo usar tu Diosa Letal para conseguir citas en Apps y en el día a día.',
    value: 14900
  }];
  const totalValue = bonuses.reduce((acc, curr) => acc + curr.value, 0);
  // 10 minute countdown
  const [timeLeft, setTimeLeft] = useState(10 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section id="oferta-final" className="py-14 bg-deep-black text-white relative scroll-mt-20" data-id="element-12">
      {/* Subtle gold decorative border top/bottom */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-13"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-14"></div>

      <div className="max-w-4xl mx-auto px-6" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-16">
          <h2 className="text-3xl sm:text-4xl font-playfair mb-4" data-id="element-17">
            Todo lo que recibís <span className="italic text-gold" data-id="element-18">hoy</span>:
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-19"></div>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-20">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="flex flex-col sm:flex-row items-center sm:items-center bg-white/5 border border-gold/20 p-6 sm:p-8 hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="mb-6 sm:mb-0 sm:mr-8 flex-shrink-0 w-full max-w-xs sm:w-40 sm:max-w-none aspect-square flex items-center justify-center" data-id="element-22">
                <img src={bonus.image} alt={bonus.imageAlt} className="w-full h-full object-cover rounded-sm drop-shadow-[0_8px_20px_rgba(201,169,97,0.25)]" data-id="element-23" />
              </div>
              <div className="flex-grow text-center sm:text-left" data-id="element-24">
                <h3 className="text-xl font-playfair font-bold text-white mb-2" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="font-inter text-gray-400 mb-4 sm:mb-0" data-id="element-26">
                  {bonus.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-center sm:text-right mt-4 sm:mt-0 sm:ml-6" data-id="element-27">
                <span className="block text-xs font-inter tracking-widest text-gray-500 uppercase mb-1" data-id="element-28">
                  Valor
                </span>
                <PriceDisplay amount={bonus.value} className="text-lg font-bold text-gold line-through opacity-80" data-id="element-29" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="bg-gold/10 border-2 border-gold p-8 sm:p-10 text-center" data-id="element-30">
          <p className="font-inter text-gray-400 uppercase tracking-widest text-sm mb-2" data-id="element-31">
            Valor Total Normal
          </p>

          <PriceDisplay amount={totalValue} className="text-3xl font-bold text-white line-through opacity-50 mb-6 block" data-id="element-32" />

          <p className="font-inter text-gold uppercase tracking-widest text-sm font-bold mb-2" data-id="element-33">
            Precio Especial - Hot Sale
          </p>
          <div className="flex items-center justify-center space-x-4 mb-2" data-id="element-34">
            <PriceDisplay amount={17990} className="text-5xl sm:text-7xl font-playfair font-bold text-white price-glow" data-id="element-35" />
            <span className="bg-bordeaux text-white text-sm font-bold px-3 py-1 rounded-sm rotate-3 shadow-lg" data-id="element-36">
              71% OFF
            </span>
          </div>
          <p className="font-inter text-gold/80 uppercase tracking-[0.3em] text-xs mb-10" data-id="element-37">
            Pesos Argentinos
          </p>

          {/* Countdown + CTA moved here, directly under the special price */}
          <div className="border-t border-gold/30 pt-8" data-id="element-38">
            <div className="countdown-glow bg-red-600 text-white px-6 sm:px-10 py-7 sm:py-9 rounded-sm mb-8 shadow-[0_0_30px_rgba(239,68,68,0.5)]" data-id="element-39">
              <h3 className="font-inter font-black uppercase tracking-wider text-xl sm:text-2xl mb-3 leading-tight" data-id="element-40">
                ¡Oferta solo por hoy!
              </h3>
              <p className="font-inter text-sm sm:text-base text-white/95 leading-snug mb-1" data-id="element-41">
                Tu lugar solo está reservado por{' '}
                <strong className="font-bold" data-id="element-42">10 minutos</strong>.
              </p>
              <p className="font-inter text-sm sm:text-base text-white/95 leading-snug mb-5" data-id="element-43">
                En caso de no acceder se cederá a otra persona.
              </p>

              <p className="font-inter text-sm sm:text-base text-white/95 mb-3" data-id="element-44">
                La oferta se termina en:
              </p>

              <div className="bg-white/10 border-2 border-white/30 rounded-sm py-3 px-6 inline-block animate-pulse" data-id="element-45">
                <div className="font-mono font-black text-5xl sm:text-7xl tabular-nums tracking-tight leading-none" data-id="element-46">
                  {String(minutes).padStart(2, '0')}:
                  {String(seconds).padStart(2, '0')}
                </div>
                <div className="flex justify-between mt-2 px-1 font-inter font-bold uppercase tracking-[0.2em] text-[10px] sm:text-xs text-white/90" data-id="element-47">
                  <span data-id="element-48">Minutos</span>
                  <span data-id="element-49">Segundos</span>
                </div>
              </div>
            </div>

            <div data-id="element-50">
              <CTAButton onClick={e => {
              // Prevent immediate navigation so the Meta Pixel request
              // has time to fire before the browser leaves the page.
              e.preventDefault();
              const href = (e.currentTarget as HTMLAnchorElement).href;
              trackEvent('AddToCart', {
                content_name: 'Pack Diosa Letal',
                content_ids: ['diosa-letal'],
                content_type: 'product',
                value: 17990,
                currency: 'ARS'
              });
              // Small delay to ensure the pixel beacon is sent.
              setTimeout(() => {
                window.location.href = href;
              }, 300);
            }} className="w-full sm:w-auto text-base sm:text-lg py-5 px-10 mb-6 !bg-red-600 hover:!bg-red-700 shadow-[0_0_30px_rgba(239,68,68,0.6)]" data-id="element-51">
                Agregar al carrito
              </CTAButton>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 text-gray-400 mt-4" data-id="element-52">
              <div className="flex items-center" data-id="element-53">
                <Lock className="w-4 h-4 mr-2" data-id="element-54" />
                <span className="text-xs font-inter uppercase tracking-wider" data-id="element-55">
                  Pago Seguro
                </span>
              </div>
              <div className="flex items-center" data-id="element-56">
                <CreditCard className="w-4 h-4 mr-2" data-id="element-57" />
                <span className="text-xs font-inter uppercase tracking-wider" data-id="element-58">
                  MercadoPago
                </span>
              </div>
              <div className="flex items-center" data-id="element-59">
                <CreditCard className="w-4 h-4 mr-2" data-id="element-60" />
                <span className="text-xs font-inter uppercase tracking-wider" data-id="element-61">
                  Todas las Tarjetas
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}